.container {
  height: 100%;
}

.backIcon {
  background-color: white;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
}

.title {
  font-size: 1.125rem; /* text-lg */
  font-weight: bold;
  margin-top: 0.5rem; /* mt-2 */
}

.subtitle {
  font-size: 0.875rem; /* text-sm */
  margin-bottom: 1rem; /* mb-4 */
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem; /* gap-4 */
  border-radius: 0.5rem;
  margin-top: 1.25rem; /* mt-5 */
  height: 100%;
  max-height: 24rem; /* max-h-96 */
  overflow-y: auto;
}

.noInfoText {
  display: none;
}

.noInfoText:last-child {
  display: block;
}
